import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { ClipboardList, ChevronDown, Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { useLang } from "@/i18n";

const LANGS = [["nl", "Nederlands"], ["en", "English"], ["ar", "العربية"]];

/** mode: "card" (needs cardId) | "blank" | "bulk" */
export default function WorkcardPrintMenu({ mode = "blank", cardId, size = "sm", className = "" }) {
  const { t, lang } = useLang();
  const [busy, setBusy] = useState(false);

  const open = async (l) => {
    setBusy(true);
    try {
      const path = mode === "card" ? `/workcards/${cardId}.pdf` : mode === "bulk" ? "/workcards/bulk.pdf" : "/workcards/blank.pdf";
      const { data } = await api.get(path, { params: { lang: l }, responseType: "blob" });
      const url = URL.createObjectURL(data);
      const w = window.open(url, "_blank", "noopener");
      if (!w) { const a = document.createElement("a"); a.href = url; a.download = `werkkaart-${l}.pdf`; a.click(); }
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (e) {
      toast.error(mode === "bulk" && e?.response?.status === 404 ? t("workcardNoOpen") : formatApiError(e));
    } finally { setBusy(false); }
  };

  const title = mode === "card" ? t("workcardPrint") : mode === "bulk" ? t("workcardBulk") : t("workcardBlank");
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size={size} variant="outline" className={`rounded-full ${className}`} disabled={busy} data-testid={`workcard-menu-${mode}`}>
          {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <ClipboardList className="h-4 w-4 mr-2" />}{title}<ChevronDown className="h-3 w-3 ml-1 opacity-60" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel className="text-xs text-muted-foreground">{t("workcardPickLang")}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {LANGS.map(([code, label]) => (
          <DropdownMenuItem key={code} onClick={() => open(code)} data-testid={`workcard-${mode}-${code}`}>
            {label}{code === lang ? <span className="ml-auto text-[10px] text-primary">●</span> : null}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
